module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-header', {
    staticClass: "main-header"
  }), _c('div', {
    staticClass: "main-content am-container"
  }, [_c('sidebar', {
    staticClass: "sidebar",
    attrs: {
      "nav": _vm.navigation,
      "menus": _vm.menus
    },
    on: {
      "select": _vm.updateNavigation
    },
    model: {
      value: (_vm.sidebarShow),
      callback: function($$v) {
        _vm.sidebarShow = $$v
      },
      expression: "sidebarShow"
    }
  }), _c('div', {
    staticClass: "article am-padding-sm"
  }, [_c('router-view')], 1)], 1), _c('main-footer', {
    staticClass: "main-footer"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f9896e2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./doc/App.vue
// module id = 87
// module chunks = 2